import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="budget-dates"
export default class extends Controller {
  static targets = ['monthLabel']
  static values = { startMonth: Number, default: 1 }

  connect() {
    this.updateMonthLabels()
  }

  update(event) {
    this.startMonthValue = event.currentTarget.value - 1
    this.updateMonthLabels()
  }

  updateMonthLabels() {
    this.monthLabelTargets.forEach((label, index) => {
      const idx = (index + this.startMonthValue) % 12
      label.textContent = this.getMonthAbbr(idx)
    })
  }

  getMonthAbbr(monthIndex) {
    return new Intl.DateTimeFormat('en-US', { month: 'short' })
      .format(new Date(2025, monthIndex, 1))
  }
}
